module.exports = __webpack_public_path__ + "static/media/pic17.525108ca.jpg";